import React from "react";
import { useSelector } from "react-redux";
import { access } from "../redux/reducers/authSlice";
import {store} from "../redux/store";

export const setAuthToken = (token) => {
  return localStorage.setItem('accessToken', token);
};

export const getTokenFromStore = () => {
    const state = store.getState();
    const token = state.auth.accessToken
    return token
}

export const logout = () => {
    localStorage.clear();
    setTimeout(() => {
        window.location.pathname = '/';
    }, 200);
};